import { Trans, useTranslation } from 'react-i18next';
import { Flex, TextComponent } from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import { useStore } from '../../helpers/use-store';
import { ContactSupportButton } from './contact-support-button';

export const FailedSendingMail = ({ isLoading }: { isLoading: boolean }) => {
  const {
    dataStore: { userStore },
  } = useStore();
  const { isMobile } = useResponsiveness();

  const { t } = useTranslation(['mailConfirmation']);

  return (
    <Flex align="center" vertical gap={15} className="mail-modal">
      <TextComponent
        level={2}
        weight={600}
        className="title"
        textAlign="center"
      >
        {t('mailConfirmation:error_title')}
      </TextComponent>
      <TextComponent textAlign="center">
        <Trans
          ns="mailConfirmation"
          i18nKey="failed_sending_mail"
          components={{ br: <br /> }}
        />
      </TextComponent>
      <TextComponent level={3} weight={500}>
        {userStore.currentUser.email}
      </TextComponent>
      <TextComponent level={8} textAlign="center">
        <Trans
          ns="mailConfirmation"
          i18nKey="not_your_email"
          components={{ br: isMobile ? <br /> : <></> }}
        />
      </TextComponent>
      <ContactSupportButton
        flow="failed-sending-mail"
        isLoading={isLoading}
        type="primary"
      />
    </Flex>
  );
};
